<fc-general-modal
  [baseId]="baseId"
  [form]="form"
  [fcModalItemContext]="fcModalItemContext"
  (saveForm)="save()"
  (cancelForm)="onCancel()"
>
  <div [formGroup]="form" class="person-web-account">
    <div class="flex-row-generic flex-row-margin">
        <!-- User Name Control start-->
        <div class="form-group">
            <label for="{{ baseId }}-user-name" translate>User Name</label>
            <div class="dropdown">
            <input
                id="{{ baseId }}-user-name"
                class="form-control"
                [ngClass]="{ error: showErrors(userNameControl, isSubmitted), 'required': isRequired(userNameControl)}"
                type="text"
                formControlName="userName"
            />
            </div>
            <div
                *ngIf="showErrors(userNameControl, isSubmitted)"
                class="incorrect-input"
                id="{{ baseId }}-warning-text-userName"
                translate
                >
            {{ userNameControl.errors | fcListValidation : 'User Name' }}
            </div>
        </div>
        <!-- User Name Control end-->

        <!-- Password Control start -->
        <div class="form-group">
            <label for="{{ baseId }}-password" translate>Password</label>
            <input
                id="{{ baseId }}-password"
                class="form-control"
                [(ngModel)]="password"
                [ngClass]="{ error: showErrors(passwordControl, isSubmitted), 'required': isRequired(passwordControl)}"
                type="text"
                formControlName="password"
            />
            <div
                *ngIf="showErrors(passwordControl, isSubmitted)"
                id="{{ baseId }}-warning-text-password"
                class="incorrect-input"
                translate
                >
                {{ passwordControl.errors | fcListValidation : 'Password' }}
            </div>
        </div>
        <!-- Password Control end-->
    </div>
    <div class="flex-row-generic flex-row-margin">
        <button
            id="fnd-configuration-reset"
            class="btn btn-light btn-flush-left btn-web-account"
            (click)="resetWebAccount()"
            type="button"
            translate
            >
            Reset Web Account
        </button>
    </div>
    <div>
        <mat-checkbox
            id="{{ baseId }}-limited-password-checkbox"
            class="password-checkbox"
            formControlName="limitedTimePassword"
            translate
            >
            One time password (limited to one day)
        </mat-checkbox>
    </div>
    <div>
        <mat-checkbox
            id="{{ baseId }}-active-checkbox"
            class="active-checkbox"
            formControlName="active"
            translate
            >
            Active
        </mat-checkbox>
    </div>
  </div>
</fc-general-modal>
